import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Prospect } from '@niko-crm/ui';
import { ProspectActions } from './prospect.actions';

export interface ProspectsState extends EntityState<Prospect> {
  total: number;
  grandTotal: number;
  page: number;
  limit: number;
  filters: Record<string, unknown>;
  loading: boolean;
  error: string | null;
}

export const prospectsAdapter: EntityAdapter<Prospect> = createEntityAdapter<Prospect>();

const initialState: ProspectsState = prospectsAdapter.getInitialState({
  total: 0,
  grandTotal: 0,
  page: 1,
  limit: 20,
  filters: {},
  loading: false,
  error: null,
});

export const prospectsReducer = createReducer(
  initialState,
  on(ProspectActions.loadProspects, (state, { filters }) => ({
    ...state,
    loading: true,
    error: null,
    filters: filters ?? state.filters,
  })),
  on(ProspectActions.loadProspectsSuccess, (state, { result }) =>
    prospectsAdapter.setAll(result.data, {
      ...state,
      total: result.total,
      page: result.page,
      limit: result.limit,
      loading: false,
    })
  ),
  on(ProspectActions.loadProspectsFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(ProspectActions.loadProspectsGrandTotalSuccess, (state, { total }) => ({ ...state, grandTotal: total })),
  on(ProspectActions.createProspectSuccess, (state, { prospect }) => prospectsAdapter.addOne(prospect, state)),
  on(ProspectActions.updateProspectSuccess, (state, { prospect }) =>
    prospectsAdapter.setOne(prospect, state)
  ),
  on(ProspectActions.createProspectFailure, (state, { error }) => ({ ...state, error })),
  on(ProspectActions.updateProspectFailure, (state, { error }) => ({ ...state, error })),
);

export const prospectsFeature = createFeature({ name: 'prospects', reducer: prospectsReducer });
